import React from 'react'

export default function Footer() {
  return (
    <footer> 
 <a className="footer-text" href="https://github.com/saramazal/react-context-example">Github repo @saramazal</a>
    
    </footer>
  )
}
